<template>
	<div style="background-color: #f2f2f4;min-height: 100%;">
	  <Header title="教学进度管理" type="0" route="/homeIndex"></Header>
	  <div class="teachingProcess-head">
		<div>
			<p class="xnxqselect" @click="showMorePop('xnxq')">{{xnxqObj.xnxqmc}}<i class="month-arrow"></i></p>
			<p class="yxselect" @click="showMorePop('skyx')">{{skdwObj.dwmc}}<i class="month-arrow"></i></p>
		</div>
	  </div>
	  <div class="teachingProcess">
		<div class="list-head">
		  <!--
			 <p>学年学期:{{xnxqObj.xnxqmc}}</p>
		  <span @click="showMorePop()">选择</span>
			--->
			<p>{{xnxqObj.xnxqmc}}学期</p>
			<ul class="timeCss">
				<li><label>录入开始时间：{{baseData.kssj}}</label></li>
				<li><label>录入结束时间：{{baseData.jssj}}</label></li>
			</ul>
		</div>
		<NOdata
		  title="暂无数据~"
		  v-if="this.pageData && this.pageData.length == 0"
		></NOdata>
		<div class="content">
		  <div class="contentDiv" style="background-color: #fff"  v-for="(item, index) in pageData" :key="index" >
			<p>{{ item.kcmc }}[{{item.kch}}]</p>
			<ul>
			  <li>开课单位：{{ item.dwmc }}</li>
			  <li>上课时间：{{ item.sksj }}</li>
			  <li>上课地点：{{ item.skdd }}</li>
			  <li>上课班级：{{ item.ktmc }}</li>
			</ul>
			<div class="xkrsmsgdiv">
				<div style="padding:0px;float: left;width: 50%;">上课人数：{{item.xkrs}}</div>
				<div style="padding:0px;float: left;width: 50%;">总学时：{{item.skxs}}</div>
			</div>
			<div style="background-color:#fff;padding-right: 6% ;padding-top:0">
				<div style="background-color: #7469f8;height: 30px;width: 80px;line-height: 30px;border-radius: 16px;color: #fff;padding: 0;text-align: center;float: right;" @click="goItem(item)">
				录入
             </div>
			</div>
		</div>
		  </div>
		 
	  </div>
	  <van-popup v-model="show" round position="bottom">
      <van-picker
        :title=title
        show-toolbar
        :columns="cloumList"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index);
          }
        "
    /></van-popup>
	</div>
  </template>
  
  <script>
  import { Api } from "../../../utils/axios";
  export default {
	data() {
	  return {
		pageData: [],
		show1: false,
		active: 0,
		title: "",
		selectLx:'0',
		show: false,
		xnxqObj:{xnxqid:'',xnxqmc:''},
		xnxqList:[],
		cloumList:[],
		skdwList:[],
		baseData:{},
		skdwObj:{dwid:'',dwmc:'全部院系'},
	  };
	},
	methods: {
	  goItem(item) {
		// 跳转教学进度界面
		this.$router.push({
		  path: "/teacher/jxjdgl_deallist",
		  query: {
			jx0404id:item.jx0404id,
			itemObj:JSON.stringify(item)
		  }
		});
	  },
	  onConfirm(value,index) {
	  if(this.selectLx=='0'){
		this.xnxqObj.xnxqid = this.xnxqList[index].value;
	    this.xnxqObj.xnxqmc = this.xnxqList[index].text;
	  }else{
		this.skdwObj.dwid = this.cloumList[index].value;
		this.skdwObj.dwmc = this.cloumList[index].text;
	  }
	  this.show = false;
	  this.searchData();
    },
	  // 弹出选择器
	  showMorePop(lx) {
		if(lx=='xnxq'){
			this.cloumList = this.xnxqList;
			this.title = "学年学期";
			this.selectLx = '0';
		}else{
			this.cloumList = this.skdwList;
			this.title = '开课院系';
			this.selectLx = '1';
		}
		this.show = true;
	  },
	  async initData(){
		const params = {
         isInitData:'1'
      };
	  
		const res = await Api.findMySkjh(params);
		if(res.code=='1'){
			if(res.xnxqdata){
				let xqList = res.xnxqdata;
				this.xnxqList = [];
				for(let i=0;i<xqList.length;i++){
					this.xnxqList.push({'text': xqList[i].xqmc,'value':xqList[i].xnxq01id});
					if(xqList[i].dqxq=='1'){
						this.xnxqObj.xnxqid = xqList[i].xnxq01id;
						this.xnxqObj.xnxqmc = xqList[i].xqmc;
						break;
					}
				}
			}
			if(res.skdwdata){
				this.skdwList = res.skdwdata;
			}
			this.pageData = res.data;
			this.baseData = res.baseData;
		}
	  },
	  async searchData(){
		this.pageData = [];
		this.baseData = [];
		const params = {
          xnxq01id: this.xnxqObj.xnxqid,
		  kkdw:this.skdwObj.dwid,
		  isInitData:'0'
        };
		const res = await Api.findMySkjh(params);
		if(res.code=='1'){
			this.pageData = res.data;
			this.baseData = res.baseData;
		}
	  }
	
	},
	created() {
		
		this.initData();
	}
  };
  </script>
  <style scoped lang="less" >
  .teachingProcess-head{
	padding: 3% 5% 10px;
	background-color: #fff;
	height: 30px;
	.xnxqselect{
		width: 40%;
		float: left;
	}
	.yxselect{
		width: 50%;
		float: right;
	}
	padding-right: 10px ;
  }
  .month-arrow{
	display: block;
    background: url(../../../../static/img/Triangle.png)no-repeat center;
    background-size: 100%;
    width: 8px;
    height: 21px;
	float:right;
	margin-right: 10px ;
  }
  .teachingProcess {
	padding: 3% 5% 0;
	background-color: #f2f2f4;
	height: 100%;
	.list-head {
	  height: auto;
	  background-image: url("../../../../static/image/head.png");
	  background-size: 100% 100%;
	  background-repeat: no-repeat;
	  display: flex;
	  padding: 3% 5%;
	  box-sizing: border-box;
	  position: relative;
	  flex-direction: column;
	  p {
		height: 14px;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #fff;
		letter-spacing: 0;
		font-weight: lighter;
		margin-bottom: 10px;
	  }
	  span {
      position: absolute;
      top: 25%;
      right: 7%;
      color: #fff;
      border-radius: 40%;
      font-size: 14px;
      padding: 1% 3%;
      background-color: #8f87f9;
    }

	}
  
	.timeCss{
		ul{
         list-style:none;
		 padding: 0;
		 font-family: PingFangSC-Medium;
         font-size: 13px;
		 font-weight: lighter;
		 margin-top:10px ;
	  }
	  li{
		//display: inline-block;
		position: relative;
		color: #ffffff;
		font-family: PingFangSC-Medium;
         font-size: 13px;
		 font-weight: lighter;
		 label{
			padding-left:12px;
		 }
		 margin-bottom: 5px;
	  }
	  li:before{
		content: '';
		position: absolute;
		left: 3px;
		top: 50%;
		-webkit-transform:translateY(-50%) ;
		transform: translateY(-50%);
		width: 7px;
		height: 7px;
		border-radius: 50%;
		background-color: #fff;
	  }
	  li:first{
		
	  }
	  li:first-child:after{
		content: '';
		position: absolute;
		left: 6px;
		top: 10px;
		bottom: 0;
		height: 18px;
		width: 1px;
		
		border-left: 1px solid #fff;
	  }
	}

	.content {
	  div {
		background: #f2f2f4;
		border-radius: 5px;
		padding: 3% 0 3% 6%;
		margin-bottom: 5%;
		position: relative;
  
		p {
		  height: 22px;
		  font-family: PingFangSC-SNaNpxibold;
		  font-size: 16px;
		  color: #333333;
		  letter-spacing: 0;
		  font-weight: 600;
		  margin-bottom: 2%;
		}
  
		ul li {
		  height: auto;
		  font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #666666;
		  letter-spacing: 0;
		  margin-bottom: 1%;
		  font-weight: 400;
		}
		span {
		  position: absolute;
		  top: calc(50% - 6px);
		  right: 5%;
		}
	  }
	}
	
  }
  .more.van-popup.van-popup--bottom {
	border-radius: 0 !important ;
  }
  .more {
	padding: 5% 0 5% 0;
	box-sizing: border-box;
	overflow: hidden;
	.van-tabs__content--animated {
	  height: 75vh;
	  overflow: auto;
	}
	.van-tabs--line .van-tabs__wrap {
	  border-bottom: 1px solid #f4f4f4;
	  .van-tab--active {
		.van-tab__text--ellipsis {
		  color: #212f6e !important;
		}
	  }
	  .van-tab__text--ellipsis {
		height: 20px;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #8f95b5;
		text-align: center;
		letter-spacing: 0;
	  }
	  .van-tabs__line {
		background-color: #7469f8 !important;
		width: 25px;
		height: 3px;
		border-radius: 1.5px;
	  }
	}
	& > p {
	  width: 64px;
	  font-weight: bolder;
	  font-family: PingFangSC-Medium;
	  font-size: 16px;
	  color: #000000;
	  letter-spacing: 0;
	  text-align: center;
	  padding-left: 7%;
	}
	ul {
	  overflow: auto;
	  height: 36vh;
	  .choose {
		background-color: #f2f2f4;
	  }
	  li {
		height: 40px;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #212f6e;
		font-weight: bold;
		display: flex;
		align-items: center;
		padding-right: 5%;
		padding-left: 7%;
		justify-content: space-between;
	  }
	}
  }

  .contentDiv{
		background-color: #fff;
	}
	.xkrsmsgdiv{
		margin-right:6% ;
		margin-top: 10px;
		height: 25px;
		font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #666666;
		  letter-spacing: 0;
		  font-weight: 400;
	}
	.lrbutomdiv{
		background-color: #7469f8;
		height: 30px;width: 80px;
		line-height: 30px;
		border-radius: 16px;
		color: #fff;
		padding: 0;
		text-align: center;
		margin-left: calc(100%-80px);
		
	}
  </style>
  


// WEBPACK FOOTER //
// src/components/teacher/jxjdgl/jxjdglindex.vue